import React from "react";
import { Stack } from "@mui/system";
import { Typography } from "@mui/material";
import IconValueVisual from "../visuals/IconValueVisual";
export interface RelatedEventCardProps {
  eventDate?: string;
  eventName?: string;
  location: string;
}
const RelatedEventCard = ({
  eventDate,
  eventName,
  location
}: RelatedEventCardProps) => {
  return (
    <Stack
      border="2px solid #E7E7E7"
      direction="row"
      p={2}
      boxShadow=" 1px 1px 4px 0px rgb(0 0 0 / 25%)"
      spacing={2}
    >
      {eventDate &&
        <Stack
          alignItems="center"
          justifyContent="center"
          className="border-1-primary"
          width="71px"
          height="71px"
          textAlign="center"
          p={2}
        >
          <Typography variant="h4" color="primary" fontWeight={400}>
            {eventDate}
          </Typography>
        </Stack>}
      <Stack justifyContent="center">
        <Typography variant="h4" fontWeight={700}>
          {eventName}
        </Typography>
        <IconValueVisual icon="far fa-map-marker-alt" value={location} />
      </Stack>
    </Stack>
  );
};

export default RelatedEventCard;
